<template>
	<div class='h-topo-treebox'>
	    <!-- 搜索框div -->
	    <div class="h-topo-treesearch" :class='{"h-borderBox-top": hasBorder}' v-if="searchBox_.show">
	      <ejs-textbox ref='baseSearch' :maxlength="30" :title='searchTreeString' :placeholder="SearchHoder" v-model="searchTreeString" @keydown.native.enter='change'></ejs-textbox>
	    </div>
	    <!-- tab页div -->
	    <div style="margin-top: 10px">
	      <ejs-tab ref='neTab' @selected="tabClicked($event)" heightAdjustMode='None'>
	        <e-tabitems>
	          <!-- <e-tabitem :header='logical' content='#logical-tree'></e-tabitem> -->
	          <e-tabitem :header='physical' content='#physical-tree'></e-tabitem>
	        </e-tabitems>
	      </ejs-tab>
	    </div>
	    <!-- 拓扑树 -->
	    <div>
	      <div id='logical-tree' style='display: none; height: calc(100vh - 220px);' class="h-topo-tree">
	        <ejs-treeview id='baseTree' ref='baseTreeLogic' :selectedNodes="selectedNodes" :enablePersistence='true' :fields='fields' :nodeClicked='nodeClicked' :showCheckBox="checkBox_.show" :nodeChecked='checkedNodesFunc'></ejs-treeview>
	      </div>
	      <div id='physical-tree' style='display: none; height: calc(100vh - 220px);' class="h-topo-tree">
	        <ejs-treeview id='baseTree' ref='baseTree' :selectedNodes="selectedNodes" :enablePersistence='true' :fields='fields' :nodeClicked='nodeClicked' :showCheckBox="checkBox_.show" :nodeChecked='checkedNodesFunc'></ejs-treeview>
	      </div>
	    </div>
	</div>
</template>

<script>

  let treeDatas = [{ children: [] }];
  let responseData = [];
  let resTemp = []

  export default {
    name: 'LeftTopoTree',
    components: {

    },
    mounted() {
      this.getTopoTreeData();
	  this.oldSelectedNodes =[], this.selectedNodes = [];
	  this.$nextTick(() => {
		this.isLogical = false;
		this.getTopoTreeData();
		this.$emit('setGraphType', this.isLogical);
		console.log('物理视图:+++++++++++++++++++++++');
		});	
    },
    props: {
      message: [String, Number],
      searchBox: {
        type: Object,
        default() {
          return {
            show: true
          };
        }
      },
      checkBox: {
        type: Object,
        default() {
          return {
            show: false
          };
        }
      },
      hasBorder: { type: Boolean, default: false },
      update: { type: Boolean, default: false },
      graphType: '',
    },
    data() {
      return {
        resultStatus: true, 	//-- 成功标志位
        isLogical: false, 		//-- 视图类型
        searchTreeString: '', 	//-- 搜索字符串
        selectedNodes : [],
        oldSelectedNodes : [],
        logical: {
          	text: this.$t('Topo.topoMonitorLogicalGraph')
        },
        physical: {
          	text: this.$t('Topo.topoMonitorPhysicalGraph')
        },
        SearchHoder: this.$t('Topo.nodeName'),
        fields: {
	          dataSource: treeDatas,
	          id: 'id',
	          text: 'name',
	          child: 'children',
	          iconCss:'icon',
	          isChecked: 'isChecked',
	          selected: 'selected',
	          tooltip: 'name',
        },
        searchBox_: this.searchBox,
        checkBox_: this.checkBox,
        neIdListCache: {},
        nodeClicked: (args) => {
          	const node = responseData[responseData.findIndex(v => v.id === args.node.dataset.uid)];
          	this.sendMessage(node.id);        
        },
      };
    },

    watch: {
      //拓扑图定位到树，将树节点选中
      message() {
      
      		this.oldSelectedNodes =[], this.selectedNodes = [];
	  		for (let i = 0; i < responseData.length; i++) {
	        	responseData[i].selected = 'false';
	        	if (responseData[i].id === this.message.toString()) {
	          		this.oldSelectedNodes = this.selectedNodes = [responseData[i].id ];
	            	responseData[i].selected = 'true';	
	            	break;
	        	}
	        }       
      }
    },
	
    methods: {    
     
      // 选择物理/逻辑视图
      tabClicked(e) {
      
      	
	        const This = this;
	        const refs = ['logicalGraph', 'physicalGraph'];
	        const curSelectedIndex = e.selectedIndex;
	        const curRef = refs[curSelectedIndex];
	        
	        this.oldSelectedNodes =[], this.selectedNodes = [];
	        if (curRef === 'logicalGraph') {
	          this.$nextTick(() => {
		            this.isLogical = true;
		            this.getTopoTreeData();
		            this.$emit('setGraphType', this.isLogical);
		            console.log('逻辑视图:+++++++++++++++++++++++');
	          });
	        } 
	        else {
		          this.$nextTick(() => {
			            this.isLogical = false;
			            this.getTopoTreeData();
			            this.$emit('setGraphType', this.isLogical);
			            console.log('物理视图:+++++++++++++++++++++++');
		          });
	        }
      },
      // 查TOPO树数据
      getTopoTreeData() {
      
        if(!this.resultStatus){
          console.log("getTopoTreeData()方法,当前已有请求,本次不发送................");
          return;
        }
        
        this.resultStatus = false;
        const isLogical = this.isLogical;
        let url = '/lte/ems/topo/logicalView';
        if (!isLogical) {
        	url = '/lte/ems/topo/physicalView';
        }        
       
        const This = this;
        This.$axios.get(url).then(response => {
	          this.resultStatus = true;
	          if(response.data === undefined || response.status !== 200){
	            return;
	          }          		
          
	          if (response.data.errorCode === 'SUCCESS') {
	              resTemp = response.data.resultVal;
	              //-- This.$options.parent.$options.parent is PhysicGraph.vue
	              This.$options.parent.$options.parent.setLeftDataSource(resTemp);
	              responseData = This.getTreeDataStyle();
	              if(this.update) {
	                	//-- 小杨专用,只显示所有设备,你们要是想要所有网元请用下面的
	              		treeDatas = This.transferDevice2TreeData(responseData);
	              } 
	              else {
	              		treeDatas = This.transfer2TreeData(responseData);	              		
	              }
	              
	              This.fields = {
	                dataSource: treeDatas,
	                id: 'id',
	                text: 'name',
	                child: 'children',
	                iconCss:'icon',
	                isChecked: 'isChecked',
	                tooltip: 'name',
	                expanded: 'name',
	              };              
	          }
	          
	          //-- handle orginal selectedNode and handle diagram
	          if( This.oldSelectedNodes.length != undefined && This.oldSelectedNodes.length > 0)
	          {
	          		setTimeout(function () {	          	
			      		const node = responseData.find( item => ( item.id == This.oldSelectedNodes[0] ) );
			          	const index = responseData.findIndex( item => ( item.id == This.oldSelectedNodes[0] ) );
					  	if(node == undefined)
					  	{
					  		This.selectedNodes = [];
					  	}		          		
			          	else
			          	{
			          		This.selectedNodes = [ This.oldSelectedNodes[0] ];
			          		responseData[index].selected = 'true';
			          		This.sendMessage( This.oldSelectedNodes[0] );
			          	}		          	
		      		}, 50);
	          }
	         
	         
        });
      },

      //  由于ej2的tree要指定节点是否具有子节点，所以需要将节点转换为Tree结构
      transfer2TreeData(treeData, parentId = 'null') {
      
	        const item = treeData.filter(item => parentId.indexOf(item.parentId) > -1);
	        if( this.selectedNodes != null && this.selectedNodes.length > 0)
	        {
	        	item.selected = 'selected';
	        }
	        
	        return  item.map(item => {
		          const { id, name, icon, selected } = item;
		          return {
		            isChecked: this.neIdListCache[id],
		            id,
		            name,
		            icon,
		            selected,
		            children: this.transfer2TreeData(treeData, new Array(`${item.id}`))
		          };
	        });
      },

      transferDevice2TreeData(treeData, parentId = '0') {
      
        return treeData
          .filter(item => ( item.typeCode >= 10001 && item.typeCode <= 10008))
          .map(item => {
            const { id, name, icon, selected } = item;
            return {
              isChecked: this.neIdListCache[id],
              id,
              name,
              icon,
              selected,
            };
          });
      },
      // 根据网元的在线状态拼样式
      getTreeDataStyle(){
        responseData = [];
        for (let i = 0; i < resTemp.length; i++) {
	          if( Number(resTemp[i].typeCode) == 30002)
	    	  		resTemp[i].onlineStatus = 1;
	          if( resTemp[i].parentId == null &&resTemp[i].typeCode==10009)//为解决UNM-861 GNB根节点一直灰色的问题
	    	  		resTemp[i].onlineStatus = 1;
	        
	          const iconStyle = resTemp[i].onlineStatus ===1?
	            'icon hero-icon'+' '+`${resTemp[i].icon}`+' '+'h-pm-iconOnline':
	            'icon hero-icon'+' '+`${resTemp[i].icon}`+' '+'h-pm-iconOffline';
	            
	          responseData.push({
	            ...resTemp[i],
	            icon:iconStyle,
	            id:`${resTemp[i].id}`,
	            parentId:`${resTemp[i].parentId}`
	          })

	          if (resTemp[i].typeCode === 0 || resTemp[i].typeCode === '0'){
	            responseData[i].icon = resTemp[i].onlineStatus === 1 ?
	              'icon hero-icon hero-icon-topo-subnet'+' '+'h-pm-iconOnline':
	              'icon hero-icon hero-icon-topo-subnet'+' '+'h-pm-iconOffline';
	          }
        }
        
      	return responseData;
      },

      // 网元树模糊搜索
      change() {
        const This = this;
        if(!this.update) {
          if (this.searchTreeString !== '') {
            const selectData = responseData
              .filter(item => item.name.indexOf(this.searchTreeString) > -1)
              .map(item => {
                const { id, name,icon } = item;
                return {
                  id,
                  name,
                  icon,
                  isChecked: !!this.neIdListCache[id],
                  children: {}
                };
              });
            if (selectData.length !== 0) {
              This.fields = {
                dataSource: selectData,
              };
            } else {
              This.fields = {
                dataSource: null,
              };
            }
          } else {
            This.fields = {
              dataSource: this.transfer2TreeData(responseData),
            };
          }
        }
        //这里还是小杨专用,所有设备模糊搜索
        else{
          if (this.searchTreeString !== '') {
            const selectData = responseData
              .filter(item => (( item.typeCode >= 10001 && item.typeCode <= 10008) && item.name.indexOf(this.searchTreeString) > -1))
              .map(item => {
                const { id, name,icon } = item;
                return {
                  id,
                  name,
                  icon,
                  isChecked: !!this.neIdListCache[id],
                  children: {}
                };
              });
            if (selectData.length !== 0) {
              This.fields = {
                dataSource: selectData,
              };
            } else {
              This.fields = {
                dataSource: null,
              };
            }
          } else {
            This.fields = {
              dataSource: this.transferDevice2TreeData(responseData),
            };
          }
        }
      },
      // 给拓扑图传网元ID
      sendMessage(args) {
      		this.$emit('sendInfo', args);
      },
      /* 监听check操作，将选中节点id加入缓存
       * author: h26635
       */
      checkedNodesFunc(args) {
	        if (args.isInteracted) {
		          if (args.action === 'check') {
		            this.neIdListCache[args.data[0].id] = true;
		          } 
		          else if (args.action === 'uncheck') {
		            this.neIdListCache[args.data[0].id] = false;
		          }
	        }
      },
      /* 取消所有选中的节点
       * author: h26635
       */
      uncheckAll() {
	        const serachObj = this.$refs.baseSearch;
	        if (serachObj) {
	          serachObj.value = '';
	        }
	        
	        let treeObj;
	        if(this.isLogical == true)
	     		treeObj = this.$refs.baseTreeLogic.ej2Instances ;
	     	else
	     		treeObj = this.$refs.baseTree.ej2Instances ;
	     		
	        //treeObj = this.$refs.baseTree.ej2Instances;
	        treeObj.uncheckAll();
	        this.neIdListCache = {};
	        this.change('');
      },
      /* 获取当前显示树选中节点数组
       * author: h26635
       */
      getNodeList() {
	      
	        let treeObj;        
	        if(this.isLogical == true)
	     		treeObj = this.$refs.baseTreeLogic.ej2Instances ;
	     	else
	     		treeObj = this.$refs.baseTree.ej2Instances ;
	     		
	        const checkIdList = treeObj.getAllCheckedNodes();
	        const nodeList = [];
	        
	        for (let i = 0; i < checkIdList.length; i++) {
	        	const node = responseData[responseData.findIndex(v => v.id === checkIdList[i])];
	        	nodeList.push(node);
	        }
	        return nodeList;
      },
      /* 获取所有缓存中选中节点数组
       * author: h26635
       */
      getCacheNodeList() {
      
	        const checkIdList = [];	       
	        Object.entries(this.neIdListCache).forEach((value) => {
		          if (value[1] === true) {
		            checkIdList.push(value[0]);
		          }
	        });
	        
	        const nodeList = [];
	        for (let i = 0; i < checkIdList.length; i++) {
		          const node = responseData[responseData.findIndex(v => v.id === checkIdList[i])];
		          nodeList.push(node);
	        }
	        return nodeList;
      },
      /* 获取网元树搜索框关键词
       * author: h26635
       */
      getSearchValue() {
        return this.$refs.baseSearch.value;
      },

      // webSocket更新在线状态, id:网元id, onStatus:状态 1:在线 0:不在线
      setOnlineStatus(id, onlineStatus) {
        
	        const changeOnlineStatus = parseInt(onlineStatus);
	        //单个处理网元在线状态
	        if(typeof id === 'number') {
	          	const index = resTemp.findIndex(v => v.id == id);
	          	if (index > -1) {
	          	
		            if(resTemp[index].typeCode === 0) {
		              resTemp[index].icon = 'hero-icon-topo-subet';
		            }
		            
		            let selectLi = document.querySelector('[data-uid='+'"'+`${id}`+'"'+']');
		            if(selectLi != null && changeOnlineStatus === 1) 
		            {
			              const aBox=this.getByClass(selectLi, 'e-list-icon icon hero-icon' +' '+ `${resTemp[index].icon}`+' '+'h-pm-iconOffline');
			              if(aBox.length>0){
			                aBox[0].setAttribute("class", 'e-list-icon icon hero-icon' +' '+ `${resTemp[index].icon}`+' '+'h-pm-iconOnline');
			              }
		            }
		            
		            if(selectLi != null && changeOnlineStatus === 0) 
		            {
			              const aBox=this.getByClass(selectLi, 'e-list-icon icon hero-icon' +' '+ `${resTemp[index].icon}`+' '+'h-pm-iconOnline');
			              if(aBox.length>0){
			                aBox[0].setAttribute("class", 'e-list-icon icon hero-icon' +' '+ `${resTemp[index].icon}`+' '+'h-pm-iconOffline');
			              }
		            }
	          }
        }
        // 批量处理网元在线状态
        if(typeof id === 'object') {
        
	          for (let i = 0; i < id.length; i++) {
		            const index = resTemp.findIndex(v => v.id == id[i]);
		            if (index > -1) {
			              if(resTemp[index].typeCode == 0) {
			                resTemp[index].icon = 'hero-icon-topo-subet';
			              }
			              let selectLi = document.querySelector('[data-uid='+'"'+`${id[i]}`+'"'+']');
			              if(changeOnlineStatus === 1) {
			                const aBox=this.getByClass(selectLi, 'e-list-icon icon hero-icon' +' '+ `${resTemp[index].icon}`+' '+'h-pm-iconOffline');
			                if(aBox.length>0){
			                  aBox[0].setAttribute("class", 'e-list-icon icon hero-icon' +' '+ `${resTemp[index].icon}`+' '+'h-pm-iconOnline');
			                }
			              }
			              if(changeOnlineStatus === 0) {
			                const aBox=this.getByClass(selectLi, 'e-list-icon icon hero-icon' +' '+ `${resTemp[index].icon}`+' '+'h-pm-iconOnline');
			                if(aBox.length>0){
			                  aBox[0].setAttribute("class", 'e-list-icon icon hero-icon' +' '+ `${resTemp[index].icon}`+' '+'h-pm-iconOffline');
			                }
			              }
		            }
	          }
        }
      },

      getByClass(oParent, sClass) {
        const aResult=[];
        const aEle=oParent.getElementsByTagName('*');
        for(let i=0;i<aEle.length;i++) {
          if(aEle[i].className==sClass) {
            aResult.push(aEle[i]);
          }
        }
        return aResult;
      },
    }
  };
</script>

<style>

</style>
